var btnShowKeepReading = document.querySelector('.keep-reading > .hide-btn > button');

if(btnShowKeepReading){
  btnShowKeepReading.onclick = () => {
    let btnSvg = btnShowKeepReading.children[0];
    
    let keepReading = document.querySelector('.keep-reading');

    if(btnSvg.classList.contains('rotate')){
      btnSvg.classList.remove('rotate');
      keepReading.style.transform = 'translate3d(0, 0, 0)';
      keepReading.style.right = '-15px';
    } else {
      btnSvg.classList.add('rotate');
      keepReading.attributes.removeNamedItem('style');
    }
  }

  let keepReadingObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if(entry.isIntersecting){
          toggleKeepReading(true);
        } else {
          toggleKeepReading(false);
        }
      });
    }
  )

  document.querySelectorAll('article > .read-more').forEach(item => {
    keepReadingObserver.observe(item);
  });
}

function toggleKeepReading(show) {
  let btnSvg = btnShowKeepReading.children[0];
  let keepReading = document.querySelector('.keep-reading');

  if(show && btnSvg.classList.contains('rotate')){
    btnSvg.classList.remove('rotate');
    keepReading.style.transform = 'translate3d(0, 0, 0)';
    keepReading.style.right = '-15px';
  } else if(!show && !btnSvg.classList.contains('rotate')){
    btnSvg.classList.add('rotate');
    keepReading.attributes.removeNamedItem('style');
  }
}